import styled from "@emotion/styled"
import { css } from "@emotion/react"

const dynamicStyle = ({ theme, isButton, isScrolled }) => css`
  ${isButton &&
  `
    &::after {
      content: "";
      transition: 0.5s;
      width: 10px;
      height: 10px;
      display: inline-block;
      transform: rotate(45deg);
      border-bottom: 1px solid ${theme.palette.primary.main};
      border-right: 1px solid ${theme.palette.primary.main};
      margin-bottom: 7px;
    }
  `}
`

const HeaderNavItemBtn = styled.button`
  background: none;
  display: flex;
  justify-content: center;
  gap: 4px;
  border: none;
  text-align: start;
  transition: 0.5s;
  cursor: pointer;
  font-size: 20px;
  line-height: 24px;
  padding: 0px;

  ${({ theme }) => theme.breakpoints.up("xl")} {
    &:hover > p {
      border-bottom: 4px solid ${({ theme }) => theme.palette.primary.main};
    }

    &:hover a p {
      padding-bottom: 3px;
      border-bottom: 1px solid transparent;

      button p {
        border: none;
      }
    }

    &:hover a p:hover {
      color: ${({ theme }) => theme.palette.primary.main};
      border-bottom: 1px solid ${({ theme }) => theme.palette.primary.main};
    }
  }

  p {
    border-bottom: 4px solid transparent;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    max-width: ${({ theme }) => theme.breakpoints.values.sm}px;
    margin: 0 auto;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }

  ${({ theme }) => theme.breakpoints.between("md", "lg")} {
    max-width: ${({ theme }) => theme.breakpoints.values.md}px;
    margin: 0 auto;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }

  ${({ theme }) => theme.breakpoints.down("xl")} {
    font-weight: 700;
    color: ${({ theme }) => theme.palette.gray["900"]};
    padding: 15px 16px;
    text-decoration: none;
    padding: 15px 16px;
    position: relative;
    display: flex;
    align-items: center;
    gap: 11px;
    font-size: 20px;
    line-height: 24px;
    width: fit-content;
    margin: 0;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "xl")} {
    max-width: ${({ theme }) => theme.breakpoints.values.lg}px;
    margin: 0 auto;
    line-height: 28px;
    align-items: center;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    color: ${({ theme }) => theme.palette.gray["900"]};
    align-items: center;

    text-decoration: none;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      transition: 0.5s;
      width: 20px;
      height: 20px;
      z-index: 20;
      top: 165%;
      display: inline-block;
      transform: rotate(-135deg);
      left: 44%;
      background-color: #fff;
      opacity: 0;
      pointer-events: none;
    }
  }

  ${({ theme }) => theme.breakpoints.down("xl")} {
    ${dynamicStyle}
  }
`

export default HeaderNavItemBtn
